/* Cups Full custom sections — Uniq Creative */
(() => {
  if (window.__cfInit) return;
  window.__cfInit = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  const locale = document.documentElement.lang || 'en-GB';
  const fmt = (cents) => {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
    } catch (e) {
      return '£' + (cents / 100).toFixed(2);
    }
  };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Cart ---------- */
  async function addToCart(formData, button, errorEl) {
    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
    if (sectionIds.length) formData.append('sections', [...new Set(sectionIds)].join(','));
    if (!formData.get('selling_plan')) formData.delete('selling_plan');

    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }
    if (errorEl) errorEl.hidden = true;

    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      });
      const data = await res.json();
      if (data.status) {
        if (errorEl) {
          errorEl.textContent = data.description || data.message || 'This item could not be added. Try again.';
          errorEl.hidden = false;
        }
        document.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { sourceId: 'cf', data: { message: data.message } } }));
        return false;
      }

      if (button) {
        button.classList.add('is-added');
        setTimeout(() => button.classList.remove('is-added'), 2000);
      }

      const hasDrawer = document.querySelector('cart-drawer-component');
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: String(formData.get('id')),
            data: {
              source: 'cf-product-form',
              itemCount: Number(formData.get('quantity')) || 1,
              productId: String(data.product_id || ''),
              variantId: String(formData.get('id')),
              sections: data.sections,
            },
          },
        })
      );
      if (hasDrawer && typeof hasDrawer.open === 'function') hasDrawer.open();
      else if (!hasDrawer) window.location.href = root + 'cart';
      return true;
    } catch (err) {
      console.error(err);
      if (errorEl) {
        errorEl.textContent = 'Something went wrong adding this to your basket. Refresh the page and try again.';
        errorEl.hidden = false;
      }
      return false;
    } finally {
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.hasAttribute('data-cf-quick-add')) {
      e.preventDefault();
      addToCart(new FormData(form), form.querySelector('[type="submit"]'));
    }
  });

  /* ---------- Product form ---------- */
  function initProduct(section) {
    if (section.dataset.cfReady) return;
    section.dataset.cfReady = '1';

    const jsonEl = section.querySelector('[data-cf-product-json]');
    const form = section.querySelector('[data-cf-product-form]');
    if (!jsonEl || !form) return;
    const data = JSON.parse(jsonEl.textContent);
    const $ = (sel, scope = section) => scope.querySelector(sel);

    const idInput = $('[data-cf-variant-id]', form);
    const planInput = $('[data-cf-selling-plan]', form);
    const planSelect = $('[data-cf-plan-select]', form);
    const priceEl = $('[data-cf-price]');
    const compareEl = $('[data-cf-compare]');
    const perCupEl = $('[data-cf-per-cup]');
    const oncePriceEl = $('[data-cf-once-price]', form);
    const oncePerCupEl = $('[data-cf-once-per-cup]', form);
    const subPriceEl = $('[data-cf-sub-price]', form);
    const subWasEl = $('[data-cf-sub-was]', form);
    const subPerCupEl = $('[data-cf-sub-per-cup]', form);
    const express = $('[data-cf-express]', form);
    const atc = $('[data-cf-atc]', form);
    const atcText = $('[data-cf-atc-text]', form);
    const errorEl = $('[data-cf-error]', form);
    const stickyPrice = $('[data-cf-sticky-price]');
    const stickyPerCup = $('[data-cf-sticky-per-cup]');
    const stickyBtn = $('[data-cf-sticky-atc]');
    const stickyText = $('[data-cf-sticky-text]');
    const qty = $('[data-cf-qty] input', form);

    const perCup = (cents) => fmt(Math.floor(cents / data.cups)) + ' per cup';
    const qtyVal = () => Math.max(1, parseInt(qty && qty.value, 10) || 1);
    const currentVariant = () => data.variants.find((v) => String(v.id) === String(idInput.value)) || data.variants[0];
    const firstPlanId = () => {
      if (planSelect) return planSelect.value;
      const v = currentVariant();
      const keys = Object.keys((v && v.plans) || {});
      return keys[0] || '';
    };
    const isSubscribed = () => {
      const r = form.querySelector('[data-cf-purchase]:checked');
      return r ? r.value === 'subscribe' : false;
    };
    let unavailable = false;

    function render() {
      const v = currentVariant();
      const sub = isSubscribed();
      const planId = firstPlanId();
      planInput.value = sub ? planId : '';
      const subPrice = planId && v.plans[planId] != null ? v.plans[planId] : v.price;
      const price = sub ? subPrice : v.price;

      priceEl.textContent = fmt(price);
      if (stickyPrice) stickyPrice.textContent = fmt(price);
      if (oncePriceEl) oncePriceEl.textContent = fmt(v.price);
      if (subPriceEl) subPriceEl.textContent = fmt(subPrice);
      if (subWasEl) {
        subWasEl.textContent = fmt(v.price);
        subWasEl.hidden = !(subPrice < v.price);
      }
      if (compareEl) {
        const was = sub && subPrice < v.price ? v.price : v.compare > v.price ? v.compare : 0;
        compareEl.textContent = was ? fmt(was) : '';
        compareEl.hidden = !was;
      }
      if (data.cups) {
        if (perCupEl) perCupEl.textContent = perCup(price);
        if (stickyPerCup) stickyPerCup.textContent = perCup(price);
        if (oncePerCupEl) oncePerCupEl.textContent = fmt(Math.floor(v.price / data.cups));
        if (subPerCupEl) subPerCupEl.textContent = fmt(Math.floor(subPrice / data.cups));
      }
      if (express) express.hidden = sub;

      const available = v.available && !unavailable;
      const label = !available ? (unavailable ? 'Unavailable' : 'Sold out') : sub ? 'Subscribe' : 'Add to basket';
      atc.disabled = !available;
      if (stickyBtn) stickyBtn.disabled = !available;
      atcText.textContent = label;
      if (available) {
        const span = document.createElement('span');
        span.className = 'cf-buy__atc-price';
        span.textContent = ' · ' + fmt(price * qtyVal());
        atcText.appendChild(span);
      }
      if (stickyText) stickyText.textContent = label;
    }

    form.addEventListener('change', (e) => {
      const t = e.target;
      if (t.matches('[data-cf-purchase], [data-cf-plan-select]')) {
        if (t.matches('[data-cf-plan-select]')) {
          const subRadio = form.querySelector('[data-cf-purchase="subscribe"]');
          if (subRadio) subRadio.checked = true;
        }
        render();
      }
      if (t.closest('[data-cf-option]')) {
        const selected = [...form.querySelectorAll('[data-cf-option]')].map(
          (fs) => (fs.querySelector('input:checked') || {}).value
        );
        const match = data.variants.find((v) => v.options.every((o, i) => o === selected[i]));
        unavailable = !match;
        if (match) {
          idInput.value = match.id;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url);
          if (match.media) section.dispatchEvent(new CustomEvent('cf:media', { detail: match.media }));
        }
        render();
      }
    });

    if (qty) {
      $('[data-cf-qty-minus]', form)?.addEventListener('click', () => {
        qty.value = Math.max(1, qtyVal() - 1);
        render();
      });
      $('[data-cf-qty-plus]', form)?.addEventListener('click', () => {
        qty.value = qtyVal() + 1;
        render();
      });
      qty.addEventListener('input', render);
    }

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (qty && (parseInt(qty.value, 10) || 0) < 1) qty.value = 1;
      addToCart(new FormData(form), atc, errorEl);
    });

    /* Sticky bar: shown whenever the main buy row is off screen */
    const sticky = $('[data-cf-sticky]');
    const buyRow = $('.cf-buy__row', form);
    if (sticky && buyRow && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      const io = new IntersectionObserver(
        ([entry]) => {
          const off = !entry.isIntersecting;
          sticky.classList.toggle('is-visible', off);
          document.body.classList.toggle('cf-sticky-on', off);
        },
        { threshold: 0 }
      );
      io.observe(buyRow);
      stickyBtn?.addEventListener('click', () => {
        addToCart(new FormData(form), stickyBtn, errorEl).then((ok) => {
          if (!ok) buyRow.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        });
      });
    }

    render();
  }

  /* ---------- Free delivery progress ---------- */
  const fmtShort = (cents) => fmt(cents).replace(/[.,]00(?=\D*$)/, '');
  function renderShip(el, total, count) {
    const threshold = parseInt(el.dataset.threshold, 10) || 0;
    if (!threshold) return;
    const text = el.querySelector('[data-cf-ship-text]');
    const bar = el.querySelector('[data-cf-ship-bar]');
    const remaining = threshold - total;
    el.classList.toggle('is-done', remaining <= 0);
    if (bar) bar.style.width = Math.min(100, Math.round((total / threshold) * 100)) + '%';
    if (!text) return;
    const strong = (s) => {
      const b = document.createElement('strong');
      b.textContent = s;
      return b;
    };
    text.textContent = '';
    if (remaining <= 0) text.append('Your basket gets ', strong('free UK delivery'));
    else if (!count) text.append(strong('Free UK delivery'), ' on orders over ' + fmtShort(threshold));
    else text.append("You're ", strong(fmt(remaining)), ' away from free UK delivery');
  }
  async function refreshShip() {
    const els = document.querySelectorAll('[data-cf-ship]');
    if (!els.length) return;
    try {
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      els.forEach((el) => renderShip(el, cart.total_price || 0, cart.item_count || 0));
    } catch (e) {
      /* keep the server-rendered message */
    }
  }
  let shipTimer;
  ['cart:update', 'cart:updated', 'cart:refresh'].forEach((ev) =>
    document.addEventListener(ev, () => {
      clearTimeout(shipTimer);
      shipTimer = setTimeout(refreshShip, 400);
    })
  );
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) refreshShip();
  });

  /* ---------- Gallery ---------- */
  function initGallery(gallery) {
    if (gallery.dataset.cfReady) return;
    gallery.dataset.cfReady = '1';
    const track = gallery.querySelector('[data-cf-gallery-track]');
    const slides = [...track.children];
    const thumbs = [...gallery.querySelectorAll('[data-cf-gallery-thumb]')];
    const current = gallery.querySelector('[data-cf-gallery-current]');
    let index = 0;

    const step = () => (slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth) || 1;
    const go = (i) => {
      index = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    const mark = (i) => {
      index = i;
      thumbs.forEach((t) => {
        const on = parseInt(t.dataset.cfGalleryThumb, 10) === i;
        t.classList.toggle('is-active', on);
        if (t.classList.contains('cf-gallery__thumb')) {
          if (on) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        }
      });
      if (current) current.textContent = i + 1;
    };

    thumbs.forEach((t) => t.addEventListener('click', () => go(parseInt(t.dataset.cfGalleryThumb, 10))));
    gallery.querySelector('[data-cf-gallery-prev]')?.addEventListener('click', () => go(index - 1));
    gallery.querySelector('[data-cf-gallery-next]')?.addEventListener('click', () => go(index + 1));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });

    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const max = track.scrollWidth - track.clientWidth;
        const i = track.scrollLeft >= max - 2 ? slides.length - 1 : Math.round(track.scrollLeft / step());
        if (i !== index) mark(Math.max(0, Math.min(slides.length - 1, i)));
      });
    }, { passive: true });

    gallery.closest('[data-cf-product]')?.addEventListener('cf:media', (e) => {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(e.detail));
      if (i > -1) go(i);
    });
  }

  /* ---------- Autoplay videos when visible ---------- */
  function initVideo(video) {
    if (video.dataset.cfReady) return;
    video.dataset.cfReady = '1';
    video.muted = true;
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) video.play().catch(() => {});
        else video.pause();
      });
    }, { rootMargin: '100px' }).observe(video);
  }

  /* ---------- Carousels (mobile scroll-snap rows) ---------- */
  function initCarousel(el) {
    if (el.dataset.cfReady) return;
    el.dataset.cfReady = '1';
    el.setAttribute('tabindex', '0');
  }

  /* ---------- Rotating USP bar (mobile) ---------- */
  function initRotator(el) {
    if (el.dataset.cfReady) return;
    el.dataset.cfReady = '1';
    const items = [...el.querySelectorAll('.cf-announce__item')];
    if (items.length < 2 || reduceMotion) return;
    let i = 0;
    let paused = false;
    el.addEventListener('mouseenter', () => (paused = true));
    el.addEventListener('mouseleave', () => (paused = false));
    el.addEventListener('focusin', () => (paused = true));
    el.addEventListener('focusout', () => (paused = false));
    setInterval(() => {
      if (paused) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  }

  /* ---------- Recommendations ---------- */
  async function initRecs(el) {
    if (el.dataset.cfReady) return;
    el.dataset.cfReady = '1';
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cf-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        el.querySelectorAll('[data-cf-carousel]').forEach(initCarousel);
      }
    } catch (e) {
      console.error(e);
    }
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-cf-product]').forEach(initProduct);
    scope.querySelectorAll('[data-cf-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-cf-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-cf-rotator]').forEach(initRotator);
    scope.querySelectorAll('[data-cf-recommendations]').forEach(initRecs);
    scope.querySelectorAll('.cf-steps__video').forEach(initVideo);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
